/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  QueryFilter,
  QueryFilter$Outbound,
  QueryFilter$outboundSchema,
} from "./queryfilter.js";

/**
 * Measure used to rank sessions. Defaults to total_cost.
 */
export const SortBy = {
  TotalCost: "total_cost",
  TotalTokens: "total_tokens",
  TotalInputTokens: "total_input_tokens",
  TotalOutputTokens: "total_output_tokens",
  ToolCallCount: "tool_call_count",
  MessageCount: "message_count",
  DurationSeconds: "duration_seconds",
} as const;
/**
 * Measure used to rank sessions. Defaults to total_cost.
 */
export type SortBy = ClosedEnum<typeof SortBy>;

/**
 * Payload for listing org-scoped chat sessions
 */
export type ListSessionsPayload = {
  /**
   * Opaque cursor for pagination
   */
  cursor?: string | undefined;
  /**
   * Optional filters; all filters are ANDed together.
   */
  filters?: Array<QueryFilter> | undefined;
  /**
   * Start time in ISO 8601 format
   */
  from: Date;
  /**
   * Number of sessions to return (1-1000)
   */
  limit?: number | undefined;
  /**
   * Measure used to rank sessions. Defaults to total_cost.
   */
  sortBy?: SortBy | undefined;
  /**
   * End time in ISO 8601 format
   */
  to: Date;
};

/** @internal */
export const SortBy$outboundSchema: z.ZodMiniEnum<typeof SortBy> = z.enum(
  SortBy,
);

/** @internal */
export type ListSessionsPayload$Outbound = {
  cursor?: string | undefined;
  filters?: Array<QueryFilter$Outbound> | undefined;
  from: string;
  limit: number;
  sort_by: string;
  to: string;
};

/** @internal */
export const ListSessionsPayload$outboundSchema: z.ZodMiniType<
  ListSessionsPayload$Outbound,
  ListSessionsPayload
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    filters: z.optional(z.array(QueryFilter$outboundSchema)),
    from: z.pipe(z.date(), z.transform(v => v.toISOString())),
    limit: z._default(z.int(), 50),
    sortBy: z._default(SortBy$outboundSchema, "total_cost"),
    to: z.pipe(z.date(), z.transform(v => v.toISOString())),
  }),
  z.transform((v) => {
    return remap$(v, {
      sortBy: "sort_by",
    });
  }),
);

export function listSessionsPayloadToJSON(
  listSessionsPayload: ListSessionsPayload,
): string {
  return JSON.stringify(
    ListSessionsPayload$outboundSchema.parse(listSessionsPayload),
  );
}
